import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import './IntroSectionDevSecOps.css';

const IntroSectionDevSecOps3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to DevSecOps
  const devSecOpsStats = [
    {
      value: '80%',
      label: 'Réduction des vulnérabilités',
      translationKey: 'devSecOps.stats.vulnerabilities',
      labelTranslationKey: 'devSecOps.stats.vulnerabilitiesLabel'
    },
    {
      value: '50%',
      label: 'Déploiements plus rapides',
      translationKey: 'devSecOps.stats.deployment',
      labelTranslationKey: 'devSecOps.stats.deploymentLabel'
    },
    {
      value: '99.9%',
      label: 'Conformité garantie',
      translationKey: 'devSecOps.stats.compliance',
      labelTranslationKey: 'devSecOps.stats.complianceLabel'
    },
    {
      value: '24/7',
      label: 'Monitoring continu',
      translationKey: 'devSecOps.stats.monitoring',
      labelTranslationKey: 'devSecOps.stats.monitoringLabel'
    }
  ];

  return (
    <div className="intro-section-home intro-section-devsecops">
      <div className="intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('devSecOps.introSection.commitment', 'Notre engagement')}</h2>
        </div>
      </div>

      <FeaturedSectionStats
        title="Sécurisez vos pipelines en moins de 3 semaines."
        subtitle="Nous vous assurons une intégration sécurisée de bout en bout, une automatisation complète des tests de sécurité, une conformité continue et une collaboration optimisée entre vos équipes Dev, Sec et Ops."
        titleTranslationKey="devSecOps.stats.title"
        subtitleTranslationKey="devSecOps.stats.subtitle"
        stats={devSecOpsStats}
        showChart={false}
      />
    </div>
  );
};

export default IntroSectionDevSecOps3;
